import { formatUsdValue } from './formatUsdValue';

export function satsToUsd(amountSats: number, bitcoinPrice: number) {
  return (amountSats / 100_000_000) * (bitcoinPrice || 0);
}

export function satsToUsdFormatted(amountSats: number, bitcoinPrice: number) {
  return formatUsdValue(satsToUsd(amountSats, bitcoinPrice));
}

export const toSats = (btcAmount: number): number => {
  return Math.floor(btcAmount * 100_000_000);
};

export const toBtc = (sats: number): number => {
  return Number.parseFloat((sats / 100_000_000).toFixed(8));
};

export function roundNumber(value: number, decimals = 0) {
  return Number(value.toFixed(decimals));
}

export function roundDown(value: number, decimals = 2) {
  const factor = 10 ** decimals;
  return Math.floor(value * factor + 1e-9) / factor;
}

export function roundUp(value: number, decimals = 2) {
  const factor = 10 ** decimals;
  return Math.ceil(value * factor - 1e-9) / factor;
}

export const roundNumberDown = roundDown;

export const isAmountClose = (value: number, target: number, precision: number) => {
  if (target === 0) {
    return Math.abs(value) <= precision;
  }

  return Math.abs(value - target) <= Math.abs(target) * precision;
};
